import api, { getErrorMessage } from './api';

const workvivoNotificationsService = {
  /**
   * Fetch the per-org notification routing matrix (12 types × {enabled, push, email}).
   * Superusers must pass `orgId`; org admins are scoped to their own org.
   */
  getConfig: async (orgId) => {
    try {
      const params = orgId ? { org_id: orgId } : {};
      const response = await api.get('/api/v1/admin/workvivo-notifications/config', { params });
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  /**
   * Bulk-update the matrix. `rows` is the full list of rows the admin sees.
   */
  updateConfig: async (rows, orgId) => {
    try {
      const params = orgId ? { org_id: orgId } : {};
      const response = await api.put(
        '/api/v1/admin/workvivo-notifications/config',
        { rows },
        { params },
      );
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  /**
   * Per-user opt-out toggle.
   */
  getMyPreference: async () => {
    try {
      const response = await api.get('/api/v1/me/preferences/workvivo-notifications');
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  setMyPreference: async (enabled) => {
    try {
      const response = await api.put(
        '/api/v1/me/preferences/workvivo-notifications',
        { enabled },
      );
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  /**
   * Whether inbound Workvivo kudos are turned into in-app recognition prompts.
   * Superusers must pass `orgId`; org admins are scoped to their own org.
   */
  getInboundKudos: async (orgId) => {
    try {
      const params = orgId ? { org_id: orgId } : {};
      const response = await api.get(
        '/api/v1/admin/workvivo-notifications/inbound-kudos',
        { params },
      );
      return response.data; // { enabled: bool }
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  updateInboundKudos: async (enabled, orgId) => {
    try {
      const params = orgId ? { org_id: orgId } : {};
      const response = await api.put(
        '/api/v1/admin/workvivo-notifications/inbound-kudos',
        { enabled },
        { params },
      );
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },
};

export default workvivoNotificationsService;
